
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CreateProjectButton from '../components/CreateProjectButton';
import { t } from '../i18n';

// Utility to get API base URL depending on environment
const getApiBaseUrl = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3000';
  }
  // Use relative URL for production
  return '';
};

const ObjectsPage = () => {
  const [objects, setObjects] = useState([]);
  const [filteredObjects, setFilteredObjects] = useState([]); // State for filtered objects
  const [searchTerm, setSearchTerm] = useState(''); // State for the search term
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${getApiBaseUrl()}/api/objects`)
      .then((response) => response.json())
      .then((data) => {
        const sortedObjects = data.sort((a, b) => a.name.localeCompare(b.name));
        setObjects(sortedObjects);
        setFilteredObjects(sortedObjects); // Initialize filtered objects
      })
      .catch((error) => console.error('Error fetching objects:', error));
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);

    // Filter objects based on the search term
    const filtered = objects.filter((object) =>
      object.name.toLowerCase().includes(value)
    );
    setFilteredObjects(filtered);
  };


  // Utility to create a slug from a string
  const slugify = (str) =>
    str
      .toString()
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .toLowerCase();

  const handleObjectClick = (object) => {
    // Always generate slug from name
    const slug = slugify(object.name);
    if (!slug || slug === 'undefined') {
      navigate('/no-results');
      return;
    }
    navigate(`/objets/${slug}`);
  };

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>{t('objectsTitle') || 'Objets opérés'}</h1>

      {/* Search Bar */}
      <div style={styles.searchContainer}>
        <input
          type="text"
          placeholder={t('searchObjectPlaceholder') || 'Rechercher un objet...'}
          value={searchTerm}
          onChange={handleSearchChange}
          style={styles.searchInput}
        />
      </div>

      {/* Display Objects */}
      {filteredObjects.length > 0 ? (
        <ul style={styles.list}>
          {filteredObjects.map((object) => (
            <li
              key={object.id}
              style={styles.listItem}
              onClick={() => handleObjectClick(object)}
            >
              {object.name}
            </li>
          ))}
        </ul>
      ) : (
        <p>{t('noObjectFound') || 'Aucun objet trouvé.'}</p>
      )}

      {/* Create Project Button */}
      <CreateProjectButton />
    </div>
  );
};

const styles = {
  page: { padding: '20px', textAlign: 'center' },
  title: { fontSize: '24px', fontWeight: 'bold', marginBottom: '20px', marginTop: '10px' },
  searchContainer: { marginBottom: '20px' },
  searchInput: {
    width: '100%',
    maxWidth: '400px',
    padding: '10px',
    fontSize: '16px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  list: { listStyleType: 'none', padding: 0 },
  listItem: {
    fontSize: '18px',
    marginBottom: '10px',
    cursor: 'pointer',
    textDecoration: 'underline',
    color: 'blue',
  },
};

export default ObjectsPage;